import React, { ReactNode, useEffect, useState } from "react";
import styles from "./PlanCard.module.scss";
import plan1GigImageD from "../../images/plan-1gig-d.jpg";
import plan2GigImageD from "../../images/plan-2gig-d.jpg";
import plan5GigImageD from "../../images/plan-5gig-d.jpg";
import { ROUTES } from "../../lib/constants";
import { Button } from "../Button/Button";
import { PlanType } from "../../lib/types";
import { Image } from "../Image/Image";

export const PlanCard = (props: {
  className?: string;
  landing?: boolean;
  type: PlanType;
  children?: ReactNode;
  gigInternetLinkText: "Learn More" | "Compare Packages";
}): React.JSX.Element => {
  const [image, setImage] = useState<string>();
  const [imageDesc, setImageDesc] = useState<string>();
  const [packageUrl, setPackageUrl] = useState<string>();

  useEffect(() => {
    if (props.type === "1 Gig") {
      setImage(plan1GigImageD);
      setImageDesc("Mother with small child looking at laptop.");
      // setPackageUrl(ROUTES.connectAndControl.path);
      setPackageUrl(ROUTES.checkAvailability.path);
    } else if (props.type === "2 Gigs") {
      setImage(plan2GigImageD);
      setImageDesc(
        "Man with headphones looking at laptop while puppy is standing on desk."
      );
      // setPackageUrl(ROUTES.workHardPlayHard.path);
      setPackageUrl(ROUTES.checkAvailability.path);
    } else if (props.type === "5 Gigs") {
      setImage(plan5GigImageD);
      setImageDesc(
        "Senior couple sitting by swimmimg pool. Man looking at laptop. Woman looking at phone."
      );
      // setPackageUrl(ROUTES.everythingAndEverywhere.path);
      setPackageUrl(ROUTES.checkAvailability.path);
    }
  }, [props.type]);

  return (
    <div
      data-landing={props.landing || false}
      className={`${styles.card} ${
        styles["card__" + props.type.replace(" ", "").toLowerCase()]
      } ${props.className || ""}`}
    >
      <div className={styles.header}>
        <h3 className="headline__h3">
          {props.type === "1 Gig" && "Connect & Control"}
          {props.type === "2 Gigs" && "Work Hard, Play Hard"}
          {props.type === "5 Gigs" && "Everything & Everywhere"}
        </h3>

        <div className={styles.imageWrap}>
          <Image
            src={image}
            alt={imageDesc}
            width="100"
            height="100"
            loading="eager"
          />
        </div>

        <div className={styles.priceWrap}>
          <p className="headline__h4">{props.type}</p>
          <p className="headline__h4">
            {props.type === "1 Gig" && "$80"}
            {props.type === "2 Gigs" && "$95"}
            {props.type === "5 Gigs" && "$195"}
            <span> / month</span>
          </p>
        </div>
      </div>

      <div className={styles.body}>{props.children}</div>

      <div
        className={styles.footer}
        data-reverse={props.gigInternetLinkText === "Compare Packages"}
      >
        <Button
          seconday={true}
          path={ROUTES.gigInternet.path}
          target="_self"
          size="lg"
        >
          {props.gigInternetLinkText}
        </Button>

        <Button
          path={packageUrl}
          target="_self"
          size="lg"
          gradient={props.type === "2 Gigs" ? "orange" : undefined}
        >
          Select Package
        </Button>
      </div>
    </div>
  );
};
